import React, { useState, useEffect } from 'react';
import api from '../services/api';

const MAANDNAMEN = ['januari','februari','maart','april','mei','juni','juli','augustus','september','oktober','november','december'];

const Maandverslag = () => {
  const nu = new Date();
  const defMaand = `${nu.getFullYear()}-${String(nu.getMonth() + 1).padStart(2, '0')}`;
  const [maand, setMaand] = useState(defMaand);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get('/analyse/maandverslag', { params: { maand } })
      .then(r => setData(r.data)).catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [maand]);

  const maandNaam = (m) => { const [j, mm] = m.split('-'); return `${MAANDNAMEN[parseInt(mm,10)-1]} ${j}`; };
  const volgendeMaandNaam = (m) => { const [j, mm] = m.split('-'); const d = new Date(parseInt(j,10), parseInt(mm,10), 1); return `${MAANDNAMEN[d.getMonth()]} ${d.getFullYear()}`; };

  const trend = (dz, vr) => {
    const d = dz - vr;
    if (vr === 0 && dz === 0) return <span style={{ color: '#6b7280' }}>—</span>;
    const pct = vr ? Math.round(d / vr * 100) : 100;
    if (d > 0) return <span style={{ color: '#ef4444', fontWeight: 600 }}>▲ +{d} ({pct > 0 ? '+' : ''}{pct}%)</span>;
    if (d < 0) return <span style={{ color: '#10b981', fontWeight: 600 }}>▼ {d} ({pct}%)</span>;
    return <span style={{ color: '#6b7280' }}>≈ gelijk</span>;
  };

  const downloadPdf = async () => {
    try {
      const r = await api.get('/maandverslag-pdf/pdf', { params: { maand }, responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url; a.download = 'maandverslag-' + maand + '.pdf';
      document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) { alert('PDF-download mislukt'); }
  };

  const card = { background: 'white', borderRadius: 10, padding: 18, border: '1px solid #e5e7eb', marginBottom: 16 };
  const th = { textAlign: 'left', padding: '6px 10px', background: '#00A888', color: 'white', fontSize: 13 };
  const td = { padding: '6px 10px', fontSize: 13, borderBottom: '1px solid #e5e7eb' };

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Laden...</div>;

  const t = data?.totaal || {};
  const dz = parseInt(t.deze_maand || 0, 10), vr = parseInt(t.vorige_maand || 0, 10);
  const logsPer = {};
  (data?.logs || []).forEach(l => { (logsPer[l.object_id] = logsPer[l.object_id] || []).push(l); });
  const matPer = {};
  (data?.materiaal_per_object || []).forEach(m => { matPer[m.naam] = m; });
  const weerPerDag = {};
  (data?.weer_per_dag || []).forEach(w => { weerPerDag[w.datum] = w; });
  const weerBadge = (datum) => {
    if (!datum) return null;
    const d = new Date(datum).toISOString().slice(0, 10);
    const w = weerPerDag[d];
    if (!w) return null;
    return <span style={{ color: '#9ca3af', fontSize: 11, marginLeft: 6 }}>
      🌡️{Math.round(w.temp_max)}°{Number(w.neerslag_mm) >= 1 ? ` 🌧️${Math.round(w.neerslag_mm)}mm` : ' ☀️'}{w.vorst ? ' ❄️' : ''}
    </span>;
  };
  const oorzObjPer = {};
  (data?.oorzaak_objecten || []).forEach(o => { (oorzObjPer[o.oorzaak] = oorzObjPer[o.oorzaak] || []).push(o); });
  const objTekst = (oorzaak) => (oorzObjPer[oorzaak] || []).slice(0,3).map(o => `${o.naam} (${o.aantal}×)`).join(', ');

  // samenvatting-data afleiden
  const oorzaken = (data?.per_oorzaak || []).map(o => ({ ...o, dz: parseInt(o.deze_maand,10), vr: parseInt(o.vorige_maand,10) }));
  const stijgers = oorzaken.filter(o => o.dz > o.vr && o.dz >= 3).sort((a,b) => (b.dz-b.vr)-(a.dz-a.vr)).slice(0,3);
  const dalers = oorzaken.filter(o => o.dz < o.vr && o.vr >= 3).sort((a,b) => (a.dz-a.vr)-(b.dz-b.vr)).slice(0,2);
  const topObjecten = (data?.terugkerend || []).slice(0, 3);
  const seizoen = data?.seizoen || {};
  const mat = data?.materiaal || {};

  return (
    <div style={{ padding: 24, maxWidth: 1000, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h1 style={{ margin: 0 }}>📅 Maandverslag — {maandNaam(maand)}</h1>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={downloadPdf} style={{ padding: '8px 14px', borderRadius: 8, border: 'none', background: '#00A888', color: 'white', fontWeight: 600, cursor: 'pointer', fontSize: 14 }}>📄 Download PDF</button>
          <select value={maand.split('-')[1]} onChange={e => setMaand(maand.split('-')[0] + '-' + e.target.value)}
                  style={{ padding: 8, borderRadius: 8, border: '1px solid #d1d5db', fontSize: 14 }}>
            {MAANDNAMEN.map((n, i) => <option key={i} value={String(i+1).padStart(2,'0')}>{n}</option>)}
          </select>
          <select value={maand.split('-')[0]} onChange={e => setMaand(e.target.value + '-' + maand.split('-')[1])}
                  style={{ padding: 8, borderRadius: 8, border: '1px solid #d1d5db', fontSize: 14 }}>
            {[2025, 2026, 2027].map(j => <option key={j} value={j}>{j}</option>)}
          </select>
        </div>
      </div>

      {!data ? <p>Geen data.</p> : <>
        {/* KPI's */}
        <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
          <div style={{ flex: 1, background: '#00A888', color: 'white', borderRadius: 10, padding: 16, textAlign: 'center' }}>
            <div style={{ fontSize: 28, fontWeight: 700 }}>{dz}</div><div style={{ fontSize: 12 }}>Storingen deze maand</div>
          </div>
          <div style={{ flex: 1, background: (dz - vr) > 0 ? '#ef4444' : '#10b981', color: 'white', borderRadius: 10, padding: 16, textAlign: 'center' }}>
            <div style={{ fontSize: 28, fontWeight: 700 }}>{dz - vr > 0 ? '+' : ''}{dz - vr}</div>
            <div style={{ fontSize: 12 }}>t.o.v. vorige maand ({vr})</div>
          </div>
          <div style={{ flex: 1, background: '#f59e0b', color: 'white', borderRadius: 10, padding: 16, textAlign: 'center' }}>
            <div style={{ fontSize: 28, fontWeight: 700 }}>{t.openstaand}</div><div style={{ fontSize: 12 }}>Nog openstaand</div>
          </div>
          <div style={{ flex: 1, background: '#6366f1', color: 'white', borderRadius: 10, padding: 16, textAlign: 'center' }}>
            <div style={{ fontSize: 28, fontWeight: 700 }}>{(data.terugkerend || []).length}</div><div style={{ fontSize: 12 }}>Terugkerende objecten</div>
          </div>
        </div>

        {/* SAMENVATTING */}
        <div style={{ background: '#0a0e1a', borderRadius: 10, padding: 18, marginBottom: 10, color: '#e2e8f0' }}>
          <h3 style={{ margin: '0 0 10px 0', color: 'white' }}>Samenvatting {maandNaam(maand)}</h3>
          {data.weer && data.weer.dagen > 0 && (
            <div style={{ background: '#111827', borderRadius: 8, padding: '8px 12px', marginBottom: 10, fontSize: 13, display: 'flex', gap: 18, flexWrap: 'wrap' }}>
              <span>🌡️ <b>{data.weer.gem_temp_max}°C</b> gem. max</span>
              <span>🌧️ <b>{data.weer.totaal_neerslag} mm</b> neerslag</span>
              <span>☀️ <b>{data.weer.droge_dagen}</b> droge dagen</span>
              {parseInt(data.weer.vorstdagen,10) > 0 && <span>❄️ <b>{data.weer.vorstdagen}</b> vorstdagen</span>}
            </div>
          )}
          <div style={{ fontSize: 13, lineHeight: 1.6 }}>
            <div style={{ color: '#00E8BB', fontWeight: 700, marginTop: 6 }}>Wat viel op</div>
            <div>{dz} storingen ({dz - vr >= 0 ? '+' : ''}{vr ? Math.round((dz-vr)/vr*100) : 0}% t.o.v. vorige maand).
              {stijgers.length > 0 && <> Grootste stijgers: {stijgers.map(o => `${o.oorzaak} (${o.vr}→${o.dz})`).join(', ')}.</>}
            </div>
            {dalers.length > 0 && <>
              <div style={{ color: '#10b981', fontWeight: 700, marginTop: 6 }}>Wat ging beter</div>
              <div>{dalers.map(o => `${o.oorzaak} daalde van ${o.vr} naar ${o.dz}`).join('; ')}.</div>
            </>}
            {topObjecten.length > 0 && <>
              <div style={{ color: '#fca5a5', fontWeight: 700, marginTop: 6 }}>Aandachtspunten</div>
              <div>Terugkerende objecten: {topObjecten.map(o => `${o.naam} (${o.aantal}×)`).join(', ')} — zie details hieronder.</div>
            </>}
            <div style={{ color: '#00E8BB', fontWeight: 700, marginTop: 6 }}>Vooruitblik {volgendeMaandNaam(maand)}</div>
            <div>Zelfde maand vorig jaar: {seizoen.zelfde_maand_vorig_jaar || 0} storingen. Volgende maand vorig jaar: {seizoen.volgende_maand_vorig_jaar || 0} — gebruik dit als seizoensindicatie.</div>
          </div>
        </div>

        {/* per oorzaak */}
        <div style={card}>
          <h3 style={{ marginTop: 0 }}>1. Storingen per oorzaak — vergelijking met vorige maand</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr><th style={th}>Oorzaak</th><th style={th}>Groep</th><th style={th}>Deze maand</th><th style={th}>Vorige</th><th style={th}>Trend</th></tr></thead>
            <tbody>
              {oorzaken.filter(o => o.dz > 0 || o.vr > 0).map((o, i) => (
                <tr key={i}>
                  <td style={td}>{o.oorzaak}</td>
                  <td style={td}><span style={{ fontSize: 11, color: '#6b7280' }}>{o.groep || '—'}</span></td>
                  <td style={td}><b>{o.dz}</b></td>
                  <td style={td}>{o.vr}</td>
                  <td style={td}>{trend(o.dz, o.vr)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* opvallend deze maand */}
        {(stijgers.length > 0 || dalers.length > 0) && (
          <div style={{ background: '#f0fdfa', border: '1.5px solid #00D4AA', borderRadius: 10, padding: 14, marginBottom: 16 }}>
            <b style={{ fontSize: 14 }}>Opvallend deze maand — welke objecten</b>
            {stijgers.map((o, i) => (
              <div key={i} style={{ fontSize: 13, marginTop: 4 }}>
                <span style={{ color: '#ef4444', fontWeight: 700 }}>▲ {o.oorzaak} {o.vr}→{o.dz}</span>
                {objTekst(o.oorzaak) ? <> — vooral op <b>{objTekst(o.oorzaak)}</b></> : ''}
              </div>
            ))}
            {dalers.map((o, i) => (
              <div key={'d'+i} style={{ fontSize: 13, marginTop: 4 }}>
                <span style={{ color: '#10b981', fontWeight: 700 }}>▼ {o.oorzaak} {o.vr}→{o.dz}</span> — verbetering
              </div>
            ))}
          </div>
        )}

        {/* verwachting volgende maand */}
        <div style={card}>
          <h3 style={{ marginTop: 0 }}>Verwachting {volgendeMaandNaam(maand)}</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr><th style={{...th, background:'#6366f1'}}>Signaal</th><th style={{...th, background:'#6366f1'}}>Verwachting</th><th style={{...th, background:'#6366f1'}}>Let op deze objecten</th></tr></thead>
            <tbody>
              <tr>
                <td style={td}><b>Volume</b></td>
                <td style={td}>{volgendeMaandNaam(maand).split(' ')[0]} vorig jaar: {seizoen.volgende_maand_vorig_jaar || 0} storingen (deze maand vorig jaar: {seizoen.zelfde_maand_vorig_jaar || 0}). Gebruik als seizoensindicatie.</td>
                <td style={td}>—</td>
              </tr>
              {stijgers.slice(0,2).map((o, i) => (
                <tr key={i}>
                  <td style={td}><b>{o.oorzaak}</b></td>
                  <td style={td}>Steeg deze maand ({o.vr}→{o.dz}); houd de trend in de gaten.</td>
                  <td style={td}><b>{objTekst(o.oorzaak) || '—'}</b></td>
                </tr>
              ))}
              {topObjecten.length > 0 && (
                <tr>
                  <td style={td}><b>Terugkerend</b></td>
                  <td style={td}>Deze objecten kwamen deze maand herhaaldelijk terug; kans op vervolg.</td>
                  <td style={td}><b>{topObjecten.map(o => o.naam).join(', ')}</b></td>
                </tr>
              )}
            </tbody>
          </table>
          <p style={{ fontSize: 11, color: '#9ca3af', marginBottom: 0 }}><i>Een verwachting is een inschatting op basis van patronen, geen zekerheid.</i></p>
        </div>

        {/* per objecttype */}
        <div style={card}>
          <h3 style={{ marginTop: 0 }}>2. Storingen per objecttype</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr><th style={th}>Objecttype</th><th style={th}>Storingen</th></tr></thead>
            <tbody>
              {(data.per_type || []).filter(p => p.categorie !== '1234').map((p, i) => (
                <tr key={i}><td style={td}>{p.categorie || '(onbekend)'}</td><td style={td}><b>{p.aantal}</b></td></tr>
              ))}
            </tbody>
          </table>
          {(data.wissel_sub || []).length > 0 && <>
            <h4 style={{ marginBottom: 6 }}>Wissels — per subcategorie</h4>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr><th style={{...th, background:'#6366f1'}}>Subcategorie</th><th style={{...th, background:'#6366f1'}}>Storingen</th></tr></thead>
              <tbody>
                {data.wissel_sub.map((w, i) => (
                  <tr key={i}><td style={td}>{w.sub}</td><td style={td}><b>{w.aantal}</b></td></tr>
                ))}
              </tbody>
            </table>
          </>}
        </div>

        {/* terugkerende objecten GECOMBINEERD: storingen + logs + materiaal */}
        <div style={card}>
          <h3 style={{ marginTop: 0 }}>3. Terugkerende storingen (2+ deze maand) — met logs en materiaal</h3>
          {(data.terugkerend || []).length === 0 ? <p style={{ color: '#9ca3af' }}>Geen terugkerende objecten deze maand.</p> :
            data.terugkerend.map((o, i) => {
              const m = matPer[o.naam];
              return (
                <div key={i} style={{ marginBottom: 14, border: '1px solid #fecaca', borderTop: '3px solid #ef4444', borderRadius: 8, overflow: 'hidden' }}>
                  <div style={{ background: '#fef2f2', padding: '8px 12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <b>{o.naam}{o.subcategorie ? ' · ' + o.subcategorie : ''} <span style={{ fontWeight: 400, color: '#6b7280' }}>({o.categorie})</span></b>
                    <span>
                      <span style={{ color: '#ef4444', fontWeight: 700 }}>{o.aantal}× storing</span>
                      {m && <span style={{ marginLeft: 12, color: '#0a0e1a', fontWeight: 700 }}>€ {Number(m.kosten).toFixed(0)} materiaal</span>}
                    </span>
                  </div>
                  <div style={{ padding: '6px 12px' }}>
                    {(o.titels || []).map((titel, j) => (
                      <div key={j} style={{ fontSize: 12, padding: '3px 0', borderBottom: '1px solid #f3f4f6' }}>
                        <span style={{ color: '#6b7280' }}>{o.datums && o.datums[j] ? new Date(o.datums[j]).toLocaleDateString('nl-NL') : ''}</span> — {titel}
                        {o.datums && o.datums[j] ? weerBadge(o.datums[j]) : null}
                      </div>
                    ))}
                    {(logsPer[o.object_id] || []).length > 0 && <>
                      <div style={{ fontSize: 11, fontWeight: 700, color: '#6b7280', marginTop: 6 }}>STORING-LOGS:</div>
                      {logsPer[o.object_id].map((l, j) => (
                        <div key={j} style={{ fontSize: 12, fontStyle: 'italic', color: '#6b7280', padding: '2px 0' }}>
                          {new Date(l.created_at).toLocaleDateString('nl-NL')} — {l.beschrijving}
                        </div>
                      ))}
                    </>}
                    {m && <>
                      <div style={{ fontSize: 11, fontWeight: 700, color: '#6b7280', marginTop: 6 }}>MATERIAAL:</div>
                      <div style={{ fontSize: 12, color: '#374151', padding: '2px 0' }}>{m.materialen} — <b>€ {Number(m.kosten).toFixed(2)}</b></div>
                    </>}
                  </div>
                </div>
              );
            })}
          {mat.registraties > 0 && <p style={{ fontSize: 12, color: '#6b7280' }}>Totaal materiaal deze maand: <b>€ {Number(mat.totaal).toFixed(2)}</b> ({mat.registraties} registraties)</p>}
        </div>

        {/* openstaand werk */}
        <div style={card}>
          <h3 style={{ marginTop: 0 }}>4. Openstaand werk</h3>
          {(data.openstaand_lijst || []).length === 0 ? <p style={{ color: '#9ca3af' }}>Niets openstaand uit deze maand.</p> :
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr><th style={{...th, background:'#f59e0b'}}>Object</th><th style={{...th, background:'#f59e0b'}}>Omschrijving</th><th style={{...th, background:'#f59e0b'}}>Status</th><th style={{...th, background:'#f59e0b'}}>Sinds</th></tr></thead>
              <tbody>
                {data.openstaand_lijst.map((w, i) => (
                  <tr key={i}>
                    <td style={td}><b>{w.object_naam || '—'}</b></td>
                    <td style={td}>{w.titel}</td>
                    <td style={td}>{w.status}</td>
                    <td style={td}>{new Date(w.created_at).toLocaleDateString('nl-NL')}</td>
                  </tr>
                ))}
              </tbody>
            </table>}
        </div>
        {/* slijtage-signalen */}
        {(data.slijtage_signalen || []).length > 0 && (
          <div style={{ ...card, border: '2px solid #f59e0b' }}>
            <h3 style={{ marginTop: 0 }}>🔧 Slijtage-signalen — mogelijk einde levensduur</h3>
            <p style={{ fontSize: 12, color: '#6b7280', marginTop: 0 }}>Objecten met 3+ storingen uit de groep slijtage (hele historie). "Versnelt" = interval wordt korter. Externe oorzaken tellen niet mee.</p>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr><th style={{...th, background:'#f59e0b'}}>Object</th><th style={{...th, background:'#f59e0b'}}>Categorie</th><th style={{...th, background:'#f59e0b'}}>Aantal</th><th style={{...th, background:'#f59e0b'}}>Gem. interval</th><th style={{...th, background:'#f59e0b'}}>Recent</th><th style={{...th, background:'#f59e0b'}}>Signaal</th></tr></thead>
              <tbody>
                {data.slijtage_signalen.map((o, i) => (
                  <tr key={i}>
                    <td style={td}><b>{o.naam}</b></td>
                    <td style={td}>{o.categorie || '—'}</td>
                    <td style={td}>{o.aantal}</td>
                    <td style={td}>{o.gem_interval} dgn</td>
                    <td style={td}>{o.recent_interval} dgn</td>
                    <td style={td}>{o.versnelt ? <span style={{ color: '#ef4444', fontWeight: 700 }}>⚠ versnelt</span> : <span style={{ color: '#6b7280' }}>stabiel</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* kosten-overzicht */}
        <div style={{ background: '#0a0e1a', borderRadius: 10, padding: 18, marginBottom: 16, color: '#e2e8f0' }}>
          <h3 style={{ margin: '0 0 10px 0', color: 'white' }}>5. Kosten-overzicht materiaal</h3>
          <div style={{ display: 'flex', gap: 20, marginBottom: 10 }}>
            <div><div style={{ fontSize: 24, fontWeight: 700, color: '#00E8BB' }}>€ {Number(mat.totaal || 0).toFixed(2)}</div><div style={{ fontSize: 11 }}>Totaal deze maand ({mat.registraties || 0} registraties)</div></div>
            <div><div style={{ fontSize: 24, fontWeight: 700 }}>€ {Number(data.materiaal_vorige?.totaal || 0).toFixed(2)}</div><div style={{ fontSize: 11 }}>Vorige maand</div></div>
          </div>
          {(data.materiaal_per_groep || []).length > 0 && <>
            <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 4 }}>Per oorzaak-groep:</div>
            {(() => {
              const tot = (data.materiaal_per_groep || []).reduce((s2, g) => s2 + Number(g.kosten || 0), 0) || 1;
              return (data.materiaal_per_groep || []).map((g, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, padding: '4px 0', borderBottom: '1px solid #1f2937' }}>
                  <span style={{ textTransform: 'capitalize' }}>{g.groep || 'onbekend'}</span>
                  <span><b>€ {Number(g.kosten).toFixed(2)}</b> <span style={{ color: '#94a3b8' }}>({Math.round(Number(g.kosten)/tot*100)}%)</span></span>
                </div>
              ));
            })()}
            <div style={{ height: 10 }} />
          </>}
          {(data.materiaal_details || []).length > 0 ? <>
            <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 4 }}>Specificatie:</div>
            {(data.materiaal_details || []).map((d, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, padding: '3px 0', borderBottom: '1px solid #1f2937' }}>
                <span>
                  <b>{d.object_naam || '—'}</b> <span style={{ color: '#94a3b8' }}>· {new Date(d.datum).toLocaleDateString('nl-NL')}</span> — {d.materiaal_naam}
                  <span style={{ color: '#94a3b8' }}> ({Number(d.aantal)}{d.eenheid ? ' ' + d.eenheid : '×'} à € {Number(d.prijs).toFixed(2)})</span>
                </span>
                <b>€ {Number(d.bedrag).toFixed(2)}</b>
              </div>
            ))}
          </> : <p style={{ fontSize: 12, color: '#94a3b8' }}>Geen materiaal-registraties deze maand.</p>}
        </div>
      </>}
    </div>
  );
};

export default Maandverslag;
